'use client';

import React, { useState } from 'react';
import moment from 'moment';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const ListItemContact = (args) => {
  const {
    id,                 // ✅ recordId Airtable (obligatoire)
    tableName = 'contact-notaire', // ✅ table Airtable (optionnelle)
    onDelete,           // ✅ callback parent optionnel
  } = args;

  const [open, setOpen] = useState(false);

  const confirmDelete = async () => {
    try {
      // ✅ suppression directe du record par ID
      const resp = await fetch(
        `https://api.airtable.com/v0/appD48APNaGA4GN0B/${encodeURIComponent(tableName)}/${encodeURIComponent(id)}`,
        {
          method: 'DELETE',
          headers: {
            Authorization:
              'Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02',
          },
        }
      );

      if (!resp.ok) {
        const e = await resp.json().catch(() => ({}));
        throw new Error(e?.error?.message || 'Suppression impossible');
      }

      // ✅ prévenir le parent pour maj UI
      await onDelete?.(id);
      setOpen(false);
      toast.success("Message supprimé.");
    } catch (e) {
      console.error('Delete error:', e);
      setOpen(false);
    }
  };

  const openMail = (email) => {
  const e = String(email || "").trim();
  if (!e || !e.includes("@")) {
    toast.error("Email non renseigné");
    return;
  }

  const href = `mailto:${encodeURIComponent(e)}`;

  try {
    // si on est dans une iframe, tente de sortir
    if (window.top && window.top !== window.self) {
      window.top.location.href = href;
      return;
    }
  } catch {
    // accès à window.top interdit (cross-origin) -> fallback
  }

  window.location.href = href;
};

  return (
    <>
      <li className="gap-x-6 py-4 border-b-2 border-slate-100 bg-white mb-4 p-4 rounded-xl">
        <div className="flex justify-between">
          <div className="flex min-w-0 gap-x-4">
            <span className="inline-block h-14 w-14 overflow-hidden rounded-full bg-gray-50">
              <svg fill="currentColor" viewBox="0 0 24 24" className="h-full w-full text-gray-300">
                <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
            </span>
            <div className="min-w-0 flex-auto">
              <p className="text-sm font-semibold leading-6 text-gray-900">
                {args.nom} {args.prenom}
              </p>
              <div className="flex">
                <p className="m-1 truncate text-sm leading-5 text-gray-500">
                  {!args.email ? (
                    <span className="text-muted">Email non renseigné / </span>
                  ) : (
                    <span>{args.email} /</span>
                  )}
                </p>
                <p className="m-1 truncate text-sm leading-5 text-gray-500">
                  {!args.telephone ? (
                    <span className="text-muted">Téléphone non renseigné</span>
                  ) : (
                    <span>{args.telephone}</span>
                  )}
                </p>
              </div>
            </div>
          </div>

          <div className="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
            <span className="inline-flex items-center rounded-md bg-indigo-50 px-2 py-1 text-sm font-semibold text-indigo-800">
              {args.type}
            </span>
            <p className="mt-1 text-sm leading-5 text-gray-500">
              Envoyé le{' '}
              <time dateTime={moment(args.date).format('YYYY-MM-DD')}>
                {moment(args.date).format('ll')}
              </time>
            </p>
          </div>
        </div>

        <div className="overflow-hidden rounded-lg bg-slate-50 my-2 p-3">
          <p>{args.message}</p>
        </div>

        <div className="mt-3 flex items-center gap-2">
          <button
  type="button"
  className="btn-primary"
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    openMail(args.email);
  }}
>
  Répondre
</button>

          <button
            type="button"
            onClick={() => setOpen(true)}
            className="rounded-md bg-red-50 px-3 py-2 text-sm font-semibold text-red-600 hover:bg-red-100"
          >
            Supprimer
          </button>
        </div>
      </li>

      {/* Modal de confirmation */}
      <Dialog open={open} onClose={setOpen} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
        />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform overflow-hidden rounded-lg bg-white p-3 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
            >
              <div className="sm:flex sm:items-start">
                
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                    Êtes-vous sûre de vouloir supprimer ce message ?
                  </DialogTitle>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Cette action est irréversible. Le message et les informations associées seront
                      définitivement supprimés.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-3 items-center sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  onClick={confirmDelete}
                  className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white hover:bg-red-500 sm:ml-3 sm:w-auto"
                >
                  Supprimer
                </button>
                <button
                  type="button"
                  data-autofocus
                  onClick={() => setOpen(false)}
                  className="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 inset-ring-1 inset-ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                >
                  Annuler
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default ListItemContact;